import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { LangContext } from "../LangContext.jsx";
class TransferInternalDossier extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            name:'',
            email:'',
            personProvider:{
                provider:{
                    rfc:'',
                    identity:''
                },dossier:{
                    title:''
                }
            }
        };
        
    }
    
    getProvider(){
        axios.get('/api/provider/'+this.props.person_provider_id).then(res=>{
            this.setState({personProvider:res.data})
        })
    }

    componentDidMount(){
        let fv;
        fv = FormValidation.formValidation(KTUtil.getById('frmProvider'), {
            fields: {
                name: {
                    validators: {
                        notEmpty: {
                            message: 'Nombre requerido'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'El nombre debe tener una longitud mínima de 4'
                        },
                    }
                },
                email: {
                    validators: {
                        notEmpty: {
                            message: 'Email requerido'
                        },
                        emailAddress: {
                            message: 'Email incorrecto'
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            this.transferDossier()
        });
    }
    async transferDossier(){
        const { lang } = this.context; 
        swal.fire({
            text: lang.get('messages.estas_seguro_de_que_deseas_hacer_la_transferencia'),
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                $('#modal-transferir').modal('hide')
                axios.post('/api/dossiers/transfer',{
                    "person_provider_id": + this.props.person_provider_id,
                    "name":this.state.name,
                    "email":this.state.email
                }).then(res=>{
                    swal.fire({
                        text: lang.get('messages.invitacion_enviada'),
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText: lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        location.reload()
                    });
                })
            }
        });
    }
    handleOpenModal() {
        this.getProvider();
    }
    handleEmailChange = (e) => {
        this.setState({ email: e.target.value });
    }

    handleNameChange = (e) => { 
        this.setState({ name: e.target.value });
    }

    render() {
        const { lang } = this.context; 
        return (
            <>
                <div className="modal fade" id="modal-transferir" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content" style={{ background: '' }}>
                        <form id="frmProvider">
                            <div className="modal-body px-15 py-10">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">{lang.get('messages.transferir_expediente_a_invitado')}</h5>
                                <div className="text-muted">{lang.get('messages.completa_la_informacion')}</div>
                                <div className="mt-10">
                                    <div className="row justify-content-center text-left">
                                        <div className="col-sm-6 form-group">
                                            <label className="text-left text-dark-65">{this.state.personProvider.provider.identity }</label> 
                                            <div className="text-dark font-weight-bold">{ this.state.personProvider?.provider.rfc }</div>
                                        </div>
                                        <div className="col-sm-6 form-group">
                                            <label className="text-left text-dark-65">{lang.get('messages.expediente_de_invitado')}</label>
                                            <div className="text-dark font-weight-bold">{ this.state.personProvider.dossier.title }</div>
                                        </div>
                                    </div>
                                    <div className="row justify-content-center text-left">
                                        <div className="col-sm-6 form-group">
                                            <label className="text-left text-dark-65">{lang.get('messages.nombre')}</label>
                                            <input id="title" type="text" name="name" className="form-control form-control-solid" autoFocus  value={this.state.name} onChange={this.handleNameChange}/>
                                        </div>
                                        <div className="col-sm-6 form-group">
                                            <label className="text-left text-dark-65">{lang.get('messages.correo_electronico')}</label>
                                            <input id="email" type="email" className="form-control form-control-solid" name="email" value={this.state.email} onChange={this.handleEmailChange}/>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div className="text-right">
                                    <button   className="btn btn-primary font-weight-bolder px-10">
                                        {lang.get('messages.transferir')}
                                    </button>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>
                </div> {/* end modal */}
            </>
        );
    }
}

export default TransferInternalDossier;

if (document.getElementById('TransferInternalDossier')) {
    ReactDOM.render(<TransferInternalDossier />, document.getElementById('TransferInternalDossier'));
}
